export default __webpack_public_path__ + "static/media/03.bf9fdfb3.jpg";